module.exports = __webpack_public_path__ + "media/images/sicherheit-2da7e375e9ba63a074ee0910caf48da9.png";